module.exports = __webpack_public_path__ + "static/favicon-664f336a98468389bcde2647475a9717.ico";